import axiosClient from "../../apis/axios-client";
import { VocabularyResponse } from "../core/types";

const VOCABULARY_PATH = "/Voice/Vocabulary";

let cached: { value: VocabularyResponse; fetchedAt: number } | null = null;
const CACHE_TTL_MS = 24 * 60 * 60 * 1000; // "cache it for the day"

/**
 * Feature flags + per-user hints (home airport, recent routes, airline
 * codes). Fetched once per session and cached — a failure here must never
 * block voice search, it's an optimisation (initialPrompt) and a gate
 * (enabled/minSupportedClientVersion), never a hard dependency.
 */
export async function getVocabulary(): Promise<VocabularyResponse | null> {
  if (cached && Date.now() - cached.fetchedAt < CACHE_TTL_MS) {
    return cached.value;
  }

  try {
    // See voiceHttp.ts — axiosClient's interceptor already unwraps to the
    // body at runtime despite axios's types saying AxiosResponse<T>.
    const value = (await axiosClient.get<VocabularyResponse>(
      VOCABULARY_PATH,
    )) as unknown as VocabularyResponse;
    cached = { value, fetchedAt: Date.now() };
    return value;
  } catch {
    return null;
  }
}
